import React, { useState, useEffect } from "react";
import JsonData from "../data/data.json";
import "./styles/NewHome.css"; // Importação correta!
import "./styles/css/style.css";
import "./styles/css/nivo-lightbox/nivo-lightbox.css";
import "./styles/css/nivo-lightbox/default.css";
// import "./styles/css/bootstrap.min.css"; //ou bootstrap.css, qual vc usar
import Benefits from "./components/benefits";
import Contact from "./components/contact";
import Features from "./components/features";
import Header from "./components/header";
import Navigation from "./components/navigation";
import About from "./components/about";
import Services from "./components/services";
import Plans from "./components/plans";
import SmoothScroll from "smooth-scroll";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const NewHome = () => {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <div>
      {landingPageData && (
        <> {/* Fragmento para renderizar múltiplos elementos */}
          <Navigation />
          <Header data={landingPageData.Header} />
          <Features data={landingPageData.Features} />
          <About data={landingPageData.About} />
          <Services data={landingPageData.Services} />
          <Plans data={landingPageData.Vendas} />
          <Benefits data={landingPageData.Benefits} />
          <Contact data={landingPageData.Contact} />
        </>
      )}
    </div>
  );
};

export default NewHome;